<div class="w-full">
  <!-- Action Buttons Bar -->
  <div class="flex flex-wrap items-center justify-between gap-3 mb-6">
    <div class="flex items-center gap-2">
      <div class="relative">
        <input type="text" [(ngModel)]="globalSearchText" (ngModelChange)="filterTable()"
          placeholder="Search all retail columns..."
          class="border border-gray-300 rounded-[5px] px-4 py-2 text-sm w-64 lg:w-80 focus:outline-none focus:border-c19725 shadow-sm" />
      </div>
      <select [(ngModel)]="itemsPerPage" (change)="filterTable()" 
        class="border border-gray-300 rounded-[5px] p-2 text-sm focus:outline-none focus:border-c19725 shadow-sm">
        <option *ngFor="let c of [5, 10, 20, 50]" [value]="c">Show {{c}} rows</option>
      </select>
      <!-- ================= FROM DATE ================= -->
  <div class="flex items-center gap-1 sm:gap-2">
    <label
      for="startDate"
      class="text-xs sm:text-sm font-medium text-gray-800 whitespace-nowrap"
    >
      From :
    </label>

    <input
      id="startDate"
      type="date"
      [(ngModel)]="startDate"
      (change)="filterTable()"
      class="border border-dcdcdc rounded-[5px] px-3 py-1 text-xs sm:text-sm focus:outline-none focus:ring-0 focus:border-c19725"
    />
  </div>

  <!-- ================= TO DATE ================= -->
  <div class="flex items-center gap-1 sm:gap-2">
    <label
      for="endDate"
      class="text-xs sm:text-sm font-medium text-gray-800 whitespace-nowrap"
    >
      To :
    </label>

    <input
      id="endDate"
      type="date"
      [(ngModel)]="endDate"
      (change)="filterTable()"
      class="border border-dcdcdc rounded-[5px] px-3 py-1 text-xs sm:text-sm focus:outline-none focus:ring-0 focus:border-c19725"
    />
  </div>
    </div>

    <div class="flex items-center gap-2 flex-wrap">
      <button (click)="downloadPDF()" class="bg-[#fff6f3] text-[#F20707] border border-[#F20707] px-3 py-1.5 rounded text-xs font-semibold hover:bg-red-50 transition">PDF</button>
      <button (click)="downloadExcel()" class="bg-[#e6ffe6] text-[#029921] border border-[#029921] px-3 py-1.5 rounded text-xs font-semibold hover:bg-green-50 transition">Excel</button>
      <button (click)="downloadCSV()" class="bg-[#e5fffb] text-[#00ad94] border border-[#00ad94] px-3 py-1.5 rounded text-xs font-semibold hover:bg-teal-50 transition">CSV</button>
      <button (click)="printTable()" class="bg-[#ecddff] text-[#5606b6] border border-[#5606b6] px-3 py-1.5 rounded text-xs font-semibold hover:bg-purple-50 transition">Print</button>
    </div>
  </div>

  <!-- Table Content -->
  <div class="overflow-x-auto border border-gray-200 rounded-lg shadow-sm">
    <table class="w-full border-separate border-spacing-0">
      <thead class="bg-gray-100 text-gray-700 text-xs uppercase font-bold">
        <tr>
          <th class="p-3 border-b border-r text-center w-12">No.</th>
          <th *ngFor="let col of columns" (click)="sortBy(col.key)" 
            class="p-3 border-b border-r cursor-pointer hover:bg-gray-200 transition text-left">
            <div class="flex items-center gap-2">
              {{ col.label }}
              <svg *ngIf="sortKey === col.key" class="w-3 h-3 text-c19725" viewBox="0 0 24 24" fill="currentColor">
                <path *ngIf="sortDirection === 'asc'" d="M12 8l6 6H6z" />
                <path *ngIf="sortDirection === 'desc'" d="M12 16l-6-6h12z" />
              </svg>
            </div>
          </th>
        </tr>
      </thead>
      <tbody class="text-sm text-gray-600 bg-white">
        <tr *ngIf="paginatedList.length === 0">
          <td [attr.colspan]="columns.length + 1" class="p-10 text-center text-gray-400 italic">
            No entries found for this specific stock item.
          </td>
        </tr>
        <tr *ngFor="let item of paginatedList; let i = index" class="hover:bg-orange-50 transition-colors">
          <td class="p-3 border-b border-r text-center text-gray-400">{{ (currentPage - 1) * itemsPerPage + i + 1 }}</td>
          <!-- IMAGE COLUMN -->
            <td class="p-3 border-b border-r text-center">
              <img 
                *ngIf="item.std_image"
                [src]="item.std_image"
                alt="Product Image"
                class="h-14 w-14 object-cover rounded-lg border border-gray-200 shadow hover:scale-110 transition duration-200"
              />
              <span *ngIf="!item.std_image" class="text-gray-400 text-xs">
                No Image
              </span>
            </td>
          <td class="p-3 border-b border-r font-mono text-blue-600 font-semibold">{{ item.std_barcode }}</td>
          <td class="p-3 border-b border-r">{{ item.std_item_code }}</td>
          <td class="p-3 border-b border-r font-medium">{{ item.category?.name }}</td>
          <td class="p-3 border-b border-r font-medium">{{ item.std_item_name }}</td>
          <td class="p-3 border-b border-r">{{ item.std_per_gm_cost_without_packaging || 'N/A' }}</td>
          <td class="p-3 border-b border-r text-center">{{ item.std_per_gm_cost_with_packaging }}</td>
          <td class="p-3 border-b border-r text-center font-bold text-gray-800">{{ item.std_stone_type }}</td>
          <td class="p-3 border-b border-r text-right">{{ item.std_item_size }}</td>
          <td class="p-3 border-b border-r text-right">{{ item.std_net_weight }}</td>
          <td class="p-3 border-b border-r text-center">{{ item.std_rate_list_code }}</td>
          <td class="p-3 border-b">{{ item.std_supplier_name }}</td>
        </tr>
      </tbody>
    </table>
  </div>

  <!-- Pagination Bar -->
  <div class="flex items-center justify-between mt-6 bg-gray-50 p-3 rounded-lg border">
    <span class="text-xs font-medium text-gray-500">
      Showing <b>{{paginatedList.length}}</b> of <b>{{filteredList.length}}</b> entries
    </span>
    <div class="flex gap-1">
      <button (click)="goToPage(currentPage - 1)" [disabled]="currentPage === 1" 
        class="px-3 py-1 border rounded text-xs font-semibold disabled:opacity-30 border-c19725 text-c19725">Prev</button>
      
      <button *ngFor="let p of pageNumbers" (click)="goToPage(p)"
        [class]="currentPage === p ? 'bg-c19725 text-white border-c19725' : 'bg-white text-c19725 border-c19725'"
        class="px-3 py-1 border rounded text-xs font-semibold transition shadow-sm">
        {{p}}
      </button>

      <button (click)="goToPage(currentPage + 1)" [disabled]="currentPage === totalPages" 
        class="px-3 py-1 border rounded text-xs font-semibold disabled:opacity-30 border-c19725 text-c19725">Next</button>
    </div>
  </div>
</div>